var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"panel-item-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-5"},[_c('h5',[_vm._v("About Panels")]),_c('p',[_vm._v("Panels are used in Studio to handle custom functionality.\n          They are visible in Studio when loaded in via the configurator and viewed/used\n          by back admins and staff. Select ‘New panel’ to get started.")]),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{
            name: 'panel-item-edit',
            params: {
              itemName: 'panel-1'
            }
          }}},[_vm._v("\n          Add Panel\n        ")])],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }